import React, { useContext, useEffect, useRef } from 'react'
import Banner from '../components/Banner'
import { YachtContext } from '../context/YachtContext';
import { Link } from 'react-router-dom';
import BookNowButton from '../components/BookNowButton';
import SkeletonCard from '../components/SkeletonCard';
import { Helmet } from 'react-helmet-async';
const Yachts = () => {
  const { categories, categoryYachts, fetchCategoriesAndYachts, config, loading, error, configLoading, configError } = useContext(YachtContext);

  const categoryRefs = useRef({});

  // useEffect(() => {
  //   if (config && config.SERVER_URL) {
  //     fetchCategoriesAndYachts();
  //   }
  // }, [config])

  useEffect(() => {
    fetchCategoriesAndYachts();
  }, [fetchCategoriesAndYachts]);

  // Loading or error states
  // if (configLoading) return <p>Loading configuration...</p>;
  // if (configError) return <p>Error loading config: {configError.message}</p>;
  // if (loading) return <p>Loading yacht categories...</p>;
  // if (error) return <p>Error fetching data: {error.message}</p>;

  const scrollToCategory = (categoryUrl) => {
    const section = categoryRefs.current[categoryUrl];
    if (section) {
      const yOffset = -100; // Adjust this value as per your navbar height
      const yPosition = section.getBoundingClientRect().top + window.pageYOffset + yOffset;
      window.scrollTo({ top: yPosition, behavior: 'smooth' });
    }
  };

  return (
    <>
     <Helmet>
            <title>
 Yachts for Rent | Luxury Yacht Rentals in Dubai

            </title>
            <meta
              name="keywords"
              content="Yacht rental dubai, Dubai yacht rental, Yacht rental dubai marina, Yachts rental dubai, Luxury yacht rental dubai, Yachts rental dubai price, Yacht rentals in dubai, Dubai yacht rentals, Party yacht rental dubai, Small yacht rental dubai, Private yacht rental dubai, Dubai yacht rental prices, Luxury yacht rental in dubai, Birthday yacht rental dubai, Yacht rental dubai for birthday, Yacht rental dubai new year’s eve, Yacht rental dubai party, Yacht rental in dubai prices, Best yacht rental dubai, Dubai marina yacht rental, Yacht rental marina dubai price, Dubai luxury yacht rental, Yacht rental dubai for couples, Luxury yacht rental dubai marina"
            />
            <meta name="description" content="Discover luxury yachts for rent in Dubai with BlueHarbour. Perfect for private events, sunset cruises, and tours. Book your premium yacht rental experience today." />
          </Helmet>


            <main id="yachts">
      <Banner img="assets/yachtimages/yachts-banner.webp" text="Luxury Yachts for Rent Dubai" />

      <section className="section-2">
        <div className="container">
          <section className="category-buttons text-md-end text-center mb-5">
            {/* <h4>Categories</h4> */}
            {categories.map((category) => (
              <button
                key={category.category_url}
                className=""
                onClick={() => scrollToCategory(category.category_url)}
              >
                {category.category}
              </button>
            ))}
          </section>
          <div>
            {loading ? (
              <div className='row'>
                {Array.from({ length: 3 }).map((_, index) => (
                  <div key={index} className="col-lg-4 mb-4">
                    <SkeletonCard />
                  </div>
                ))}
              </div>
            ) : categories && categories.length > 0 ? (
              categories.map((category) => (
                <section key={category.category_url}
                  className='category-section mt-md-5 mt-3'
                  id={category.category_url}
                  ref={el => categoryRefs.current[category.category_url] = el}>
                  <h2 className="text-center">{category.category}</h2>
                  <p className="text-center">
                    Discover the pinnacle of opulence and performance with our {category.category} yachts.
                  </p>
                  <div className="row">
                    {/* Map through yachts of this category */}
                    {categoryYachts[category.category_url] && categoryYachts[category.category_url].length > 0 ? (
                      categoryYachts[category.category_url].map((yacht) => (
                        <div key={yacht.id} className="col-lg-4 col-md-6 mt-4">
                          <div className="yacht-card">
                            <div className="image-wrapper">
                              <img src={yacht.preview} alt={yacht.yacht_name} />
                            </div>
                            <div className="card-content">
                              <h5>{yacht.yacht_name}</h5>
                              <small>{yacht.model_no}</small>
                              <div>
                                <div className="detail-item mt-2">
                                  <span className="label">Brand</span>
                                  <span className="value">{yacht.yacht_name}</span>
                                </div>
                                <div className="detail-item">
                                  <span className="label">Category</span>
                                  <span className="value">{category.category}</span>
                                </div>
                                <div className="detail-item">
                                  <span className="label">Size</span>
                                  <span className="value">{yacht.passenger_capacity} Guests</span>
                                </div>

                              </div>
                              <div className="mt-3">
                                <Link to={`/yacht-details/${yacht.url_title}`}>
                                  <button className="know-more me-2">Know More</button>
                                </Link>

                                {/* <button className="book-btn">Book Now</button> */}
                                <BookNowButton buttonText="Book Now" buttonClass="book-btn" yachtId={yacht.id} yachtName={yacht.yacht_name} />

                              </div>
                            </div>
                          </div>
                        </div>
                      ))
                    ) : (
                      <p>No yachts available in this category.</p>
                    )}
                  </div>
                </section>
              ))
            ) : (
              <p>No categories available.</p>
            )}

          </div>
        </div>
      </section>
    </main>
          </>

  )
}

export default Yachts